<template>
  <div>

    <div class="modal" v-if="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
      <div class="modal-main">
        <div class="title-area" id="modal-moving">
          <h2>かぶせ設定</h2>
        </div>
      <div class="input-area">
        <div v-if="errorMessage.text" class="error_message">
          {{ errorMessage.text }}<br>
          {{ fieldErrorMessages.size }}<br>
          {{ fieldErrorMessages.ratio }}
        </div>
        <div v-for="(errorMessage, idx) in errorMessages" :key="idx" class="error_message">
          {{ errorMessage }}
        </div>
        <div>
          <div>
            <span class="label">上：</span>
            <select v-model="form.top.wrapType" :disabled="form.top.dummyFlg || form.top.panelFlg || form.top.openFlag">
              <option :value="{}" disabled>選択してください</option>
              <option v-for="(wrap,index) in doorWrapTypeList" :key="index" :value="wrap.code">{{ wrap.label }}</option>
            </select>
            <div class="error_message">{{ fieldErrorMessages.topWrap }}</div>
            <div v-if="dispInputForm(form.top.dummyFlg, form.top.wrapType, form.top.openFlag)">
              <span class="label">値：</span>
              <input type="number" class="sm" v-model.number="form.top.wrapDist" placeholder='' :disabled="form.top.panelFlg">
              <span class="sub-label" v-if="form.top.ajustHalfFlg">※半被せ</span>
              <div class="error_message">{{ fieldErrorMessages["top.wrapType"] }}</div>
              <div class="error_message">{{ fieldErrorMessages["top.wrapDistRequired"] }}</div>
            </div>
          </div>
        </div>
        <div>
          <div>
            <span class="label">左：</span>
            <select v-model="form.left.wrapType" :disabled="form.left.dummyFlg || form.left.panelFlg || form.left.openFlag">
              <option :value="{}" disabled>選択してください</option>
              <option v-for="(wrap,index) in doorWrapTypeList" :key="index" :value="wrap.code">{{ wrap.label }}</option>
            </select>
            <div class="error_message">{{ fieldErrorMessages.leftWrap }}</div>
            <div v-if="dispInputForm(form.left.dummyFlg, form.left.wrapType, form.left.openFlag)">
              <span class="label">値：</span>
              <input type="number" class="sm" v-model.number="form.left.wrapDist" placeholder='' :disabled="form.left.panelFlg">
              <span class="sub-label" v-if="form.left.ajustHalfFlg">※半被せ</span>
              <div class="error_message">{{ fieldErrorMessages["left.wrapType"] }}</div>
              <div class="error_message">{{ fieldErrorMessages["left.wrapDistRequired"] }}</div>
            </div>
          </div>
          <div>
            <span class="label">右：</span>
            <select v-model="form.right.wrapType" :disabled="form.right.dummyFlg || form.right.panelFlg || form.right.openFlag">
              <option :value="{}" disabled>選択してください</option>
              <option v-for="(wrap,index) in doorWrapTypeList" :key="index" :value="wrap.code">{{ wrap.label }}</option>
            </select>
            <div class="error_message">{{ fieldErrorMessages.rightWrap }}</div>
            <div v-if="dispInputForm(form.right.dummyFlg, form.right.wrapType, form.right.openFlag)">
              <span class="label">値：</span>
              <input type="number" class="sm" v-model.number="form.right.wrapDist" placeholder='' :disabled="form.right.panelFlg">
              <span class="sub-label" v-if="form.right.ajustHalfFlg">※半被せ</span>
              <div class="error_message">{{ fieldErrorMessages["right.wrapType"] }}</div>
              <div class="error_message">{{ fieldErrorMessages["right.wrapDistRequired"] }}</div>
            </div>
          </div>
        </div>
        <div>
          <div>
            <span class="label">下：</span>
            <select v-model="form.bottom.wrapType" :disabled="form.bottom.dummyFlg || form.bottom.panelFlg || form.bottom.openFlag">
              <option :value="{}" disabled>選択してください</option>
              <option v-for="(wrap,index) in doorWrapTypeList" :key="index" :value="wrap.code">{{ wrap.label }}</option>
            </select>
            <div class="error_message">{{ fieldErrorMessages.bottomWrap }}</div>
            <div v-if="dispInputForm(form.bottom.dummyFlg, form.bottom.wrapType, form.bottom.openFlag)">
              <span class="label">値：</span>
              <input type="number" class="sm" v-model.number="form.bottom.wrapDist" placeholder='' :disabled="form.bottom.panelFlg">
              <span class="sub-label" v-if="form.bottom.ajustHalfFlg">※半被せ</span>
              <div class="error_message">{{ fieldErrorMessages["bottom.wrapType"] }}</div>
              <div class="error_message">{{ fieldErrorMessages["bottom.wrapDistRequired"] }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="button-area">
        <button type="button" class="main_btn" @click="onOk">設定</button>
        <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as Api from '../../../utils/Api'
import * as SpaceUtil from '../../../utils/Space'
import * as CalcUtil from '../../../utils/Calc'
import {API_URL, KEY_CODE} from '../../../constants/App'
import { DOOR_WRAP_TYPE, OBJECT_DTL_TYPE, PLANNING_TYPE, ATTRIBUTE_KEY } from '../../../constants/Type'

export default {
  name: 'SetDoorWrapModal',
  components: {},
  props: {
    fileData: Object,
    editCtrlSpaces: Array,
    globalSpaceMap: Map
  },
  data () {
    return {
      modalShown: false,
      form: {
        spaceIds: [],
        spaceJoincd: String,
        right: {
          wrapType: '',
          wrapDist: '',
          dummyFlg: false,
          ajustHalfFlg: false,
          panelFlg: false,
          openFlag: false
        },
        left: {
          wrapType: '',
          wrapDist: '',
          dummyFlg: false,
          ajustHalfFlg: false,
          panelFlg: false,
          openFlag: false
        },
        top: {
          wrapType: '',
          wrapDist: '',
          dummyFlg: false,
          ajustHalfFlg: false,
          panelFlg: false,
          openFlag: false
        },
        bottom: {
          wrapType: '',
          wrapDist: '',
          dummyFlg: false,
          ajustHalfFlg: false,
          panelFlg: false,
          openFlag: false
        }
      },
      attrModel: {},
      multipleSpaceFlg: false,
      errorMessages: {},
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      // TODO Formが他のFormをもつとき、エラーメッセージがxxx.xxxになってしまう
      /** 項目別エラーメッセージ */
      fieldErrorMessages: {
        'right.wrapType': '',
        'right.wrapDistRequired': '',
        'left.wrapType': '',
        'left.wrapDistRequired': '',
        'top.wrapType': '',
        'top.wrapDistRequired': '',
        'bottom.wrapType': '',
        'bottom.wrapDistRequired': ''

      },
      doorWrapTypeList: DOOR_WRAP_TYPE,
      dispDistWrapType: DOOR_WRAP_TYPE.DEFAULT.code
    }
  },
  computed: {
  },
  watch: {
    modalShown: function () {
      if (this.modalShown) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    /** モーダル表示 */
    showModal: function () {
      this.modalShown = true
      if (!this.editCtrlSpaces) {
        this.modalShown = false
        return
      }
      let spaceIds = []
      this.editCtrlSpaces.forEach(space => {
        if (space.planningType === PLANNING_TYPE.UNIT_DRAWER) {
          let frontUC = space.childrenSpaceModel.find(
            e => e.spaceObjectDtlType === OBJECT_DTL_TYPE.UNITCOMP_FRONT_DRAWER.code)
          if (frontUC) {
            spaceIds.push(frontUC.id)
          }
        } else {
          spaceIds.push(space.id)
        }
      })
      this.multipleSpaceFlg = spaceIds.length > 1
      this.form.spaceIds = spaceIds
      this.form.spaceJoincd = this.editCtrlSpaces[0].spaceJoincd
      this.setDefaultForm(spaceIds)
      this.setDoorOpen()
    },

    /** 設定ボタン押下時 */
    onOk: function (event) {
      if (!this.modalShown) return
      event.preventDefault()
      this.clearMessages()
      this.setDoorWrap()
    },
    /** キャンセルボタン押下時 */
    onCancel: function (event) {
      event.preventDefault()
      this.clearMessages()
      this.clearForm()
      this.modalShown = false
    },
    /** enter/escキー押下時 */
    onKeydown: function (event) {
      if (
        !event.ctrlKey &&
        !event.shiftKey &&
        !event.altKey &&
        event.keyCode === KEY_CODE.ENTER
      ) {
        this.onOk(event)
      } else if (event.keyCode === KEY_CODE.ESC) {
        this.onCancel(event)
      }
    },
    /** ドア被せの更新 */
    setDoorWrap: function () {
      let payload = {
        spaceIds: this.form.spaceIds,
        spaceJoincd: this.form.spaceJoincd,
        right: {
          wrapType: this.form.right.wrapType,
          wrapDist: this.form.right.wrapType === DOOR_WRAP_TYPE.DEFAULT.code ? this.form.right.wrapDist : ''
        },
        left: {
          wrapType: this.form.left.wrapType,
          wrapDist: this.form.left.wrapType === DOOR_WRAP_TYPE.DEFAULT.code ? this.form.left.wrapDist : ''
        },
        top: {
          wrapType: this.form.top.wrapType,
          wrapDist: this.form.top.wrapType === DOOR_WRAP_TYPE.DEFAULT.code ? this.form.top.wrapDist : ''
        },
        bottom: {
          wrapType: this.form.bottom.wrapType,
          wrapDist: this.form.bottom.wrapType === DOOR_WRAP_TYPE.DEFAULT.code ? this.form.bottom.wrapDist : ''
        }
      }
      axios.post(API_URL.PLANNING + '/door-wrap', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.errorMessages = response.data.errorMessage.split(/\r?\n/g)
          } else {
            this.modalShown = false
            this.clearForm()
            this.clearMessages()
            this.$emit('setResponseData', response)
          }
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
        })
    },
    /** 初期値の設定 */
    setDefaultForm: function (spaceIds) {
      // 対象のアトリビュートを取得
      let attrModelList = this.fileData.attributeModelList
        .filter(e => spaceIds.includes(e.spaceId) && e.attKeycd === ATTRIBUTE_KEY.UT_FLAG_DOOR_WRAP)
      // 対象の空間が複数の場合、同一の被せタイプを持つアトリビュートを除外
      let count = attrModelList.reduce((attList, att1) => {
        if (!attList.some((att2) => att2.attValue1 === att1.attValue1 && att2.attValue2 === att1.attValue2 &&
          att2.attValue3 === att1.attValue3 && att2.attValue4 === att1.attValue4)) {
          attList.push(att1)
        }
        return attList
      }, []).length
      this.attrModel = attrModelList[0]
      if (spaceIds.length === 1) {
        // 選択空間が１つの場合
        this.setCurrentDist(spaceIds[0])
      } else if (count === 1) {
        // 選択空間が複数、かつすべてが同一の被せタイプを持つ場合
        this.setCurrentDistForSpaces(attrModelList)
      }
    },
    /** 扉の開き方向 */
    setDoorOpen: function () {
      let spaceIds = []
      this.editCtrlSpaces.forEach(space => {
        if (space.planningType === PLANNING_TYPE.UNIT_DOOR) {
          space.childrenSpaceModel.forEach(e => {
            if (e.spaceObjectDtlType === OBJECT_DTL_TYPE.PART_DOOR.code) {
              spaceIds.push(e.id)
            }
          })
        }
      })
      // 扉開き
      let openType = this.fileData.attributeModelList
        .filter(e => spaceIds.includes(e.spaceId) && e.attKeycd === ATTRIBUTE_KEY.PT_DOOR_OPEN_TYPE)

      openType.forEach(type => {
        let doorOpen = type.attValue1
        switch (doorOpen) {
          // LEFT
          case 1:
            this.form.left.openFlag = true
            break
          // RIGHT
          case 2:
            this.form.right.openFlag = true
            break
          // UP
          case 3:
            this.form.top.openFlag = true
            break
          // DOWN
          case 4:
            this.form.bottom.openFlag = true
            break
          default:
            break
        }
      })
    },
    //* 既存の被せ情報を設定（単一空間）*/
    setCurrentDist: function (doorId) {
      let linkedDoorAtt = this.fileData.attributeModelList.find(att => {
        return (att.attKeycd === ATTRIBUTE_KEY.SP_CELL_LINKED_DOOR ||
                att.attKeycd === ATTRIBUTE_KEY.SP_CELL_LINKED_PANEL) &&
                att.attValue1 === doorId
      })
      const panelFlg = linkedDoorAtt.attKeycd === ATTRIBUTE_KEY.SP_CELL_LINKED_PANEL
      let cell = SpaceUtil.getGlobalSpace(linkedDoorAtt.spaceId, this.globalSpaceMap)
      // セルに接するパーツを取得
      axios.get(API_URL.PLANNING + '/wrap-parts/' + cell.id)
        .then(response => {
          let outestParts = response.data.data
          let unit = SpaceUtil.getGlobalSpace(doorId, this.globalSpaceMap)
          // 被せサイズ
          this.form.right.wrapDist = CalcUtil.round((unit.x + unit.w) - (cell.x + cell.w), 2)
          this.form.left.wrapDist = CalcUtil.round(cell.x - unit.x, 2)
          this.form.top.wrapDist = CalcUtil.round((unit.y + unit.h) - (cell.y + cell.h), 2)
          this.form.bottom.wrapDist = CalcUtil.round(cell.y - unit.y, 2)
          // 被せタイプ
          this.form.right.wrapType = this.attrModel.attValue1
          this.form.left.wrapType = this.attrModel.attValue2
          this.form.top.wrapType = this.attrModel.attValue3
          this.form.bottom.wrapType = this.attrModel.attValue4
          this.checkDummyUnit(outestParts, panelFlg)
          this.checkFullWrap(outestParts)
        }).catch(error => {
          Api.handleError(error)
        })
    },
    /** 既存の被せ情報を設定（複数空間） */
    setCurrentDistForSpaces: function (attrModelList) {
      this.form.right.wrapType = this.attrModel.attValue1
      this.form.left.wrapType = this.attrModel.attValue2
      this.form.top.wrapType = this.attrModel.attValue3
      this.form.bottom.wrapType = this.attrModel.attValue4
      // 固定値指定の場合は、数値も同一なら初期値に設定
      if (this.attrModel.attValue1 === DOOR_WRAP_TYPE.DEFAULT.code) {
        let count = attrModelList
          .reduce((attList, att1) => {
            if (!attList.some((att2) => att2.attDouble1 === att1.attDouble1)) {
              attList.push(att1)
            }
            return attList
          }, []).length
        if (count === 1) {
          this.form.right.wrapDist = attrModelList[0].attDouble1
        }
      }
      if (this.attrModel.attValue2 === DOOR_WRAP_TYPE.DEFAULT.code) {
        let count = attrModelList
          .reduce((attList, att1) => {
            if (!attList.some((att2) => att2.attDouble2 === att1.attDouble2)) {
              attList.push(att1)
            }
            return attList
          }, []).length
        if (count === 1) {
          this.form.left.wrapDist = attrModelList[0].attDouble2
        }
      }
      if (this.attrModel.attValue3 === DOOR_WRAP_TYPE.DEFAULT.code) {
        let count = attrModelList
          .reduce((attList, att1) => {
            if (!attList.some((att2) => att2.attDouble3 === att1.attDouble3)) {
              attList.push(att1)
            }
            return attList
          }, []).length
        if (count === 1) {
          this.form.top.wrapDist = attrModelList[0].attDouble3
        }
      }
      if (this.attrModel.attValue4 === DOOR_WRAP_TYPE.DEFAULT.code) {
        let count = attrModelList
          .reduce((attList, att1) => {
            if (!attList.some((att2) => att2.attDouble4 === att1.attDouble4)) {
              attList.push(att1)
            }
            return attList
          }, []).length
        if (count === 1) {
          this.form.bottom.wrapDist = attrModelList[0].attDouble4
        }
      }
    },
    /** 上下左右のダミー板チェック */
    checkDummyUnit: function (outestParts, panelFlg) {
      if (outestParts.RIGHT.spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_CONST_.code) {
        this.form.right.dummyFlg = true
      }
      if (outestParts.LEFT.spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_CONST_.code) {
        this.form.left.dummyFlg = true
      }
      if (outestParts.TOP.spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_CONST_.code) {
        this.form.top.dummyFlg = true
      }
      if (outestParts.BOTTOM.spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_CONST_.code) {
        this.form.bottom.dummyFlg = true
      }
      if (panelFlg) {
        this.form.right.panelFlg = true
        this.form.left.panelFlg = true
        this.form.top.panelFlg = true
        this.form.bottom.panelFlg = true
      }
    },
    /** 全被せが調整されて半被せになっているかのチェック */
    checkFullWrap: function (outestParts) {
      if (this.form.right.wrapType === DOOR_WRAP_TYPE.ALL.code) {
        this.form.right.ajustHalfFlg = this.isHalf(this.form.right.wrapDist, outestParts.RIGHT.w)
      }
      if (this.form.left.wrapType === DOOR_WRAP_TYPE.ALL.code) {
        this.form.left.ajustHalfFlg = this.isHalf(this.form.left.wrapDist, outestParts.LEFT.w)
      }
      if (this.form.top.wrapType === DOOR_WRAP_TYPE.ALL.code) {
        this.form.top.ajustHalfFlg = this.isHalf(this.form.top.wrapDist, outestParts.TOP.h)
      }
      if (this.form.bottom.wrapType === DOOR_WRAP_TYPE.ALL.code) {
        this.form.bottom.ajustHalfFlg = this.isHalf(this.form.bottom.wrapDist, outestParts.BOTTOM.h)
      }
    },
    /** 被せサイズが半被せかの判定 */
    isHalf: function (dist, partSize) {
      if (dist === partSize / 2) {
        return true
      }
      return false
    },
    /** 被せサイズ入力欄の表示判定 */
    dispInputForm: function (dummy, wrapType, openType) {
      if (wrapType !== DOOR_WRAP_TYPE.DEFAULT.code) return false
      if (!dummy && (!this.multipleSpaceFlg || wrapType === this.dispDistWrapType) && !openType) {
        return true
      }
      return false
    },
    clearForm: function () {
      this.form = {
        right: {
          wrapType: '',
          wrapDist: '',
          dummyFlg: false,
          ajustHalfFlg: false,
          panelFlg: false,
          openFlag: false
        },
        left: {
          wrapType: '',
          wrapDist: '',
          dummyFlg: false,
          ajustHalfFlg: false,
          panelFlg: false,
          openFlag: false
        },
        top: {
          wrapType: '',
          wrapDist: '',
          dummyFlg: false,
          ajustHalfFlg: false,
          panelFlg: false,
          openFlag: false
        },
        bottom: {
          wrapType: '',
          wrapDist: '',
          dummyFlg: false,
          ajustHalfFlg: false,
          panelFlg: false,
          openFlag: false
        }
      }
    },
    clearMessages: function () {
      this.errorMessage = { text: '' }
      this.fieldErrorMessages = {
        'right.wrapType': '',
        'right.wrapDistRequired': '',
        'left.wrapType': '',
        'left.wrapDistRequired': '',
        'top.wrapType': '',
        'top.wrapDistRequired': '',
        'bottom.wrapType': '',
        'bottom.wrapDistRequired': ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
.input-area {
  overflow: auto;
  max-height: calc(100% - 110px);
  >div {
    min-height: 70px;
    display: flex;
    justify-content: center;
    margin-top: 5px;
    margin-bottom: 15px;
    >div {
      min-width: 300px;
    }
  }
}
.label {
  display: inline-block;
  text-align: right;
  min-width: 50px;
}
.sub-label {
  display: inline-block;
  text-align: left;
  width: 60px;
  color: red;
  font-size: 13px;
}
input.sm {
  width: 60px;
}
select {
  width: 195px
}
.modal .modal-main {
  width: 60%;
  max-width: 80%;
}
.modal .modal-main .input-area {
  padding: 10px 0px;
}

</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/SetDoorWrapModal.vue